import { render, staticRenderFns } from "./HomePartners.vue?vue&type=template&id=1b554722&scoped=true"
import script from "./HomePartners.vue?vue&type=script&lang=js"
export * from "./HomePartners.vue?vue&type=script&lang=js"
import style0 from "./HomePartners.vue?vue&type=style&index=0&id=1b554722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b554722",
  null
  
)

export default component.exports